import { render } from "./EzerAssistantBubble.vue?vue&type=template&id=4d07e4e4"
import script from "./EzerAssistantBubble.vue?vue&type=script&lang=js"
export * from "./EzerAssistantBubble.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__